import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginationQueryParams',
})
export class PaginationQueryParams implements PipeTransform {
  transform(direction: number, total: number, inputCurrentPage: number): any {
    let queryParams = {};
    const currentPage = inputCurrentPage || 1;

    switch (direction) {
      case -1:
        queryParams = {
          page: currentPage + direction < 1 ? 1 : currentPage + direction,
        };
        break;
      case 1:
        queryParams = {
          page: currentPage + direction > total ? total : currentPage + direction,
        };
        break;
      case total:
        queryParams = {
          page: total,
        };
        break;
      case 0:
        queryParams = {
          page: 1,
        };
        break;

      default:
        queryParams = {
          page: undefined,
        };
        break;
    }

    return queryParams;
  }
}

@NgModule({
  declarations: [PaginationQueryParams],
  exports: [PaginationQueryParams],
  providers: [PaginationQueryParams],
  imports: [CommonModule],
})
export class PaginationQueryParamsModule {}
